import React, { useEffect, useState } from "react";
import { api, formatApiError, photoUrl } from "@/lib/api";
import { toast, confirmDialog } from "@/lib/ui";
import { Camera, Check, X, Users } from "lucide-react";

export default function PhotoRequests() {
  const [data, setData] = useState({ received: [], sent: [] });
  const [tab, setTab] = useState("received");
  const [err, setErr] = useState("");

  const load = async () => {
    try { const { data } = await api.get("/photos/access-requests"); setData(data); }
    catch (e) { setErr(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const decide = async (id, action) => {
    try { await api.post(`/photos/access-requests/${id}/decide`, { action }); await load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const list = tab === "received" ? data.received : data.sent;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-7" data-testid="photo-requests-page">
      <div className="eyebrow flex items-center gap-2"><Camera className="h-3 w-3" /> Private fotos</div>
      <h1 className="mt-2 font-serif text-4xl text-olive-700">Foto-adgang</h1>
      <p className="mt-2 text-sm text-brown-600 max-w-xl">Du kontrollerer hvem der ser dine private fotos. Beslutninger kan altid ændres.</p>

      {err && <div className="mt-4 text-destructive text-sm">{err}</div>}

      <div className="mt-6 inline-flex rounded-full border border-sand-300 p-1 bg-white">
        <TabBtn active={tab === "received"} onClick={() => setTab("received")} testid="tab-received">Modtaget ({data.received?.length || 0})</TabBtn>
        <TabBtn active={tab === "sent"} onClick={() => setTab("sent")} testid="tab-sent">Sendt ({data.sent?.length || 0})</TabBtn>
      </div>

      {list.length === 0 ? (
        <div className="mt-8 card-soft p-10 text-center text-brown-500">Ingen anmodninger.</div>
      ) : (
        <ul className="mt-6 space-y-3">
          {list.map((r) => (
            <li key={r.id} className="card-soft p-4 flex items-center justify-between gap-3 flex-wrap" data-testid={`req-${r.id}`}>
              <div className="min-w-0">
                <div className="text-sm font-medium text-olive-700">
                  {tab === "received"
                    ? (r.requester?.display_name || r.requester?.name || "En bruger") + (r.requester?.city ? ` · ${r.requester.city}` : "")
                    : "Din anmodning"}
                </div>
                {r.message && <div className="text-xs text-brown-500 mt-0.5 italic">„{r.message}"</div>}
                <div className="text-[10px] text-brown-400 mt-1">Status: {statusLabel(r.status)} · {new Date(r.created_at).toLocaleDateString("da-DK")}</div>
              </div>
              {tab === "received" && r.status === "pending" && (
                <div className="flex gap-2">
                  <button onClick={() => decide(r.id, "decline")} className="btn-secondary text-xs px-3 py-1.5" data-testid={`decline-${r.id}`}><X className="h-3 w-3" /> Afvis</button>
                  <button onClick={() => decide(r.id, "grant")} className="btn-primary text-xs px-3 py-1.5" data-testid={`grant-${r.id}`}><Check className="h-3 w-3" /> Godkend</button>
                </div>
              )}
              {tab === "received" && r.status === "granted" && (
                <button onClick={() => decide(r.id, "revoke")} className="btn-ghost text-xs text-destructive" data-testid={`revoke-${r.id}`}>Tilbagekald</button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function TabBtn({ children, active, onClick, testid }) {
  return (
    <button onClick={onClick} className={`px-4 py-1.5 rounded-full text-sm ${active ? "bg-olive-500 text-white" : "text-brown-600 hover:bg-sand-100"}`} data-testid={testid}>
      {children}
    </button>
  );
}

function statusLabel(s) {
  const m = { pending: "afventer", granted: "godkendt", declined: "afvist", revoked: "tilbagekaldt" };
  return m[s] || s;
}
